import React from 'react'
import moment from "moment";
import CalendarPicker from "../portico/calendar-picker/calendar-picker";
import Textarea from "../portico/textarea/textarea";
import Radiogroup from "../portico/radiogroup/radiogroup";
import { styled } from '@mui/material/styles';
import CONSTANTS from "../../utils/constants";

const StyledTextArea = styled(Textarea)({
  height: '82px',
  padding: '0px',
  "& div:nth-of-type(2)": { height: '0px' },
  "& div": {
    height: '82px',
  },
  "& textarea": {
    height: '82px',
    color: ' #212121',
  },
  "& :focus": {
    border: "2px solid var(--input-focus-border-color)",
  }
});

export const CustomTextArea = (props: any) => {
  const {
    value,
    watch,
    fieldName,
    errors,
    register,
    setValue,
    minValue,
    maxValue
  } = props;
  return (
    <StyledTextArea
      label={fieldName}
      name={fieldName}
      value={value}
      onChange={e => { setValue(fieldName, e.target.value);}}
      inputRef={register({
        required: {
          value: false,
          message: ' '
        },
        minLength: {
          value: minValue,
          message: ' '
        },    
        maxLength: {
          value: maxValue,
          message: ' '
        }
      })}
      error={errors[fieldName]}
      min={minValue}
      max={maxValue}
      watch={watch}
      setValue={setValue}

    />
  )
}

export const RadioButtonRender = (props: any) => {
  const {
    value,
    watch,
    fieldName,
    errors,
    register,
    setValue,
    options,
    label
  } = props;
  return (
    <Radiogroup
      name={fieldName}
      label={label || fieldName}
      items={options}
      inputRef={register({
        required: {
          value: true,
          message: 'A value is required'
        }
      })}
      value={value}
      error={errors[fieldName]}
      onChange={(event, value) => { setValue(fieldName, value)}}

    />
  )
}
export const CalendarPickerRender = (props: any) => {
  const {
    fieldName,
    getValues,
    errors,
    register,
    setValue,
    label,
    unregister,
    minDate,
    maxDate,
    inputFormat
  } = props;
  return (
    <CalendarPicker
      name={fieldName}
      label={label}
      value={getValues(fieldName)}
      // fieldDescription={label}
      views={ ["year", "month"]}
      required={false}
      inputFormat={inputFormat}
      ref={register(fieldName, {
        required: {
          value: true,
          message: ' '
        },
        validate: value => {
          const dateValue = moment(value);
          if (!dateValue.isValid()) {
            return CONSTANTS.INVALID_DATE_MSG;
          }
          if (moment(value).isBefore(minDate)) {
            return CONSTANTS.FISCAL_YEAR_END_DATE_ERROR_MSG;
          }
          if (moment(value).isAfter(maxDate)) {
            return CONSTANTS.INVALID_DATE_MSG;
          }
        }
      })}
      error={errors[fieldName]}
      setValue={setValue}
      minDate={minDate}
      maxDate={maxDate}

    />)
}